import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import {
  customerTagFromModel,
  validateCustomerTagCondition,
  type CustomerTagState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_TAG = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerTagState>>,
): ConditionType<CustomerTagState, ModelCondition.CustomerTag> => ({
  name: "Customer tags",
  description(state) {
    return `Customer tags: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<CustomerTagState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return customerTagFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.CUSTOMER_TAG, tags: state };
  },
  valid(state) {
    return validateCustomerTagCondition(state).valid;
  },
});

export { type CustomerTagState } from "@redotech/redo-model/return-flow/condition-validate";
